import { Component, OnInit } from '@angular/core';
import { Estado } from '@tivic-team/manager-ts/dist/grl';
import { ParentFormGroup } from 'app/tools/parent-formgroup';
import { EstadoService } from '../../../../../../services/grl/estado.service';

@Component({
  selector: 'dropdown-uf-rg',
  templateUrl: './dropdown-uf-rg.component.html',
  styleUrls: ['./dropdown-uf-rg.component.scss'],
  viewProviders: [ParentFormGroup]
})
export class DropdownUfRgComponent implements OnInit {

  estados: Array<Estado>

  constructor(private _estadoService: EstadoService) { }

  async ngOnInit() {
    this.estados =  await this._estadoService.findEstados();
  }

}
